import { DeviceType } from 'services/partition/types'

import { IconWithTooltip, Text } from 'components'
import { generateDeviceCode, getDeviceInfo } from 'utilities/devices'

import { ReactComponent as ExclamationOrange } from 'assets/svg/exclamationOrange.svg'

import styles from './DeviceUninstalledCard.module.scss'

type DeviceUninstalledCardProps = {
  type: string
  name: string
  code?: string
  isUbisafe?: boolean
  notVinculated: boolean
}

export const DeviceUninstalledCard = ({
  type,
  name,
  code,
  isUbisafe,
  notVinculated,
}: DeviceUninstalledCardProps) => {
  const isUbisafeCode = isUbisafe && code
  const formattedCode = isUbisafeCode ? generateDeviceCode(code, type) : code

  return (
    <div className={styles.device}>
      {getDeviceInfo((type === '6' ? '99' : type) as DeviceType)?.image}
      <div>
        <p>{name}</p>
        <small>
          {getDeviceInfo((type === '6' ? '99' : type) as DeviceType)?.type}{' '}
          {notVinculated && (
            <IconWithTooltip
              Icon={ExclamationOrange}
              text="Equipamento não vinculado à instalação"
            />
          )}
        </small>
        {formattedCode && (
          <Text size="sm" weight="light">
            {formattedCode}
          </Text>
        )}
      </div>
    </div>
  )
}
